import createAction from '../../../../util/createAction';

export const CHANGE_SEN = 'addon/form/CHANGE_SEN';
export const changeSen = createAction(CHANGE_SEN);

export const CHANGE_EMAIL = 'addon/form/CHANGE_EMAIL';
export const changeEmail = createAction(CHANGE_EMAIL);
